import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import {
  getStartedOfferRequestIdsForBuyer,
  getUnreviewedCompletedOfferRequestIdsForBuyer,
} from "modules/Buyer/OfferRequests/selectors"

const mapStateToProps = (state: Store) => ({
  onGoingJobs: getStartedOfferRequestIdsForBuyer(state),
  completedJobs: getUnreviewedCompletedOfferRequestIdsForBuyer(state),
})

export default connect(mapStateToProps)(View)
